import template from "./api-select-search.html";
import {apiSelectSearchController} from "./api-select-search.controller";
import "./api-select-search.scss";

export const apiSelectSearchComponent = {
    template,
    controller: apiSelectSearchController,
    controllerAs: "apiSelectSearch",
    bindings: {
        model: "=",
        itemLabel: "@",
        itemValue: "@",
        label: "<",
        searchLabel: "<",
        collection: "@",
        required: "@",
        onValueChange: "&",
        allowNoValue: "@",
        multiple: "<",
        selectedValues: "<",
        width: "@",
        fullValue: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/api-select-search/api-select-search.component.js